module.exports = __webpack_public_path__ + "static/media/dashboard_mock.9da38f9b.png";